import React from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import SignIn from '../screens/SignIn';
import AppSwitcher from '../screens/AppSwitcher/AppSwitcher';
import TroubleLoggingIn from '../screens/TroubleLoggingIn/trouble-logging-in';
import CreateAccount from '../screens/CreateAccount/create-account';
import ResetPasswordOrActivateAccount from '../screens/ResetPassword';
import AuthenticatedRouteWrapper from './authenticated-route';
import { oktaAuthJSClient } from '../okta';
import { Security, LoginCallback } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { createBrowserHistory } from 'history';

export const ROUTES = {
  ROOT: '/',
  SIGNIN: '/signin',
  CREATE_ACCOUNT: '/create-account',
  TROUBLE_LOGGING_IN: '/trouble-logging-in',
  IMPLICIT_CALLBACK: '/callback',
  APP_SWITCHER: '/app-switcher',
  // Route defined by Okta, so not very intuitive
  // /login?recoveryToken=TOKEN   redirects to /signin/recovery/TOKEN
  // /login?activationToken=TOKEN redirects to /signin/recovery/TOKEN
  RESET_PASSWORD_OR_ACTIVATE_ACCOUNT: '/login',
};

const history = createBrowserHistory();

function AppRouter() {
  function authHandler() {
    history.push(ROUTES.ROOT);
  }

  async function restoreOriginalUri(_oktaAuth, originalUri) {
    history.push(
      toRelativeUrl(originalUri || '/', window.location.origin, {
        replace: true,
      }),
    );
  }

  return (
    <Router history={history}>
      <Security oktaAuth={oktaAuthJSClient} onAuthRequired={authHandler} restoreOriginalUri={restoreOriginalUri}>
        <Switch>
          <Route path={ROUTES.ROOT} exact component={SignIn} />
          <Route path={ROUTES.CREATE_ACCOUNT} exact component={CreateAccount} />
          <Route path={ROUTES.TROUBLE_LOGGING_IN} exact component={TroubleLoggingIn} />
          <Route path={ROUTES.IMPLICIT_CALLBACK} component={LoginCallback} />
          <Route path={ROUTES.RESET_PASSWORD_OR_ACTIVATE_ACCOUNT} component={ResetPasswordOrActivateAccount} />
          <AuthenticatedRouteWrapper path={ROUTES.APP_SWITCHER} component={AppSwitcher} />
          <Redirect path={ROUTES.SIGNIN} to={ROUTES.ROOT} />
        </Switch>
      </Security>
    </Router>
  );
}

export default AppRouter;
